import { render, staticRenderFns } from "./DashboardBlock.vue?vue&type=template&id=93ddc49a&"
import script from "./DashboardBlock.vue?vue&type=script&lang=ts&"
export * from "./DashboardBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports